import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Box, 
  Typography, 
  Container, 
  Paper, 
  Button
} from '@mui/material';
import { Cancel as CancelIcon } from '@mui/icons-material';

const PaymentCancelledPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <CancelIcon 
          sx={{ 
            fontSize: 80, 
            color: 'warning.main', 
            mb: 2 
          }} 
        />
        
        <Typography variant="h4" component="h1" gutterBottom color="warning.main">
          Payment Cancelled
        </Typography>
        
        <Typography variant="body1" paragraph color="text.secondary">
          Your payment was cancelled. No charges have been made to your account.
        </Typography>

        <Typography variant="body2" paragraph color="text.secondary">
          If you experienced any issues during checkout, please try again or contact support.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 4 }}>
          <Button 
            variant="contained" 
            onClick={() => navigate('/test-stripe')}
          >
            Try Again
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => navigate('/')}
          >
            Back to Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default PaymentCancelledPage; 